module.exports = __webpack_public_path__ + "static/media/arrow.fbfad7c2.svg";